import { inject } from '@angular/core';
import { AppSettingsQuery } from 'chronos-shared';

export const approveGuard = () => {
  const appSettingsQuery: AppSettingsQuery = inject(AppSettingsQuery);
  return appSettingsQuery.isApprovalReportEnabled$;
};
